import { render, staticRenderFns } from "./PhotosView.vue?vue&type=template&id=86f748f8&scoped=true&"
import script from "./PhotosView.vue?vue&type=script&lang=js&"
export * from "./PhotosView.vue?vue&type=script&lang=js&"
import style0 from "./PhotosView.vue?vue&type=style&index=0&id=86f748f8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86f748f8",
  null
  
)

export default component.exports